var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/modules/_cof.js
// module id = 622
// module chunks = 0